
import { TypedVue } from "@/store/types";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import { Modal } from "bootstrap";
import { systemAPI } from "@/lib/s3PlatformApi";
import { V2Project } from "@/store/admin/adminTypes";
import { Actions } from "@/store/admin/adminActions";
import { Action } from "vuex-class";

const namespace = "admin";
@Component({})
export default class AddProjectModal extends TypedVue {
  @Ref("create-project-modal")
  readonly modal!: Modal;

  @Prop()
  show!: boolean;

  projectName = "";
  projectDescription = "";

  errorText = "";
  isSaving = false;

  @Action(Actions.GET_ORG_PROJECTS, { namespace })
  getProjects!: () => Promise<V2Project[]>;

  @Watch("show")
  onShowChange(show: boolean) {
    if (show) {
      this.modal.show();
    } else {
      this.modal.hide();
    }
  }

  createProject(): void {
    this.isSaving = true;
    this.errorText = "";

    systemAPI
      .createProject({
        name: this.projectName,
        description: this.projectDescription,
      })
      .then(async () => {
        await this.getProjects();
      })
      .catch(() => {
        this.errorText = "Error creating project. Please try again later.";
      })
      .finally(() => {
        this.isSaving = false;
        this.close();
      });
  }

  close(): void {
    this.projectName = "";
    this.projectDescription = "";
    this.errorText = "";
    this.isSaving = false;
    this.$emit("close");
  }
}
